// ==========================================================================
// Base 链支持（当前仅"连接钱包 + 切换网络"，未实现任何授权/approve）
//
// ENABLE_BASE：主开关。设为 false 可完全关闭 Base（连接入口失效）。
// 说明：
//   - Base 不在默认连接顺序里，只有显式 ?chain=base（或 preferredChain=BASE）
//     才会走 Base，因此不会暴露给普通用户。
//   - 授权(approve)功能未开放：连到 Base 后授权按钮会被拦截，不发起任何链上授权。
// ==========================================================================

export const ENABLE_BASE = true;

// Base 主网（EVM，chainId 8453 = 0x2105）
export const BASE_CHAIN = {
  chainIdHex: "0x2105",
  chainIdNum: 8453,
  chainName: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: ["https://mainnet.base.org"],
  blockExplorerUrls: ["https://basescan.org"],
};
